module.exports = __webpack_public_path__ + "static/media/category19.5ac125b2.png";